import React, { Component } from "react";

import { Card, CardBody, Col, Container, Form, Row } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
//import { getEvents } from "../../store/events/actions";
import { setManagersReportDate } from "../../../store/reporting/actions";
import { getOffers } from "../../../store/offers/actions";
import { getCampaignSourcesList } from "../../../store/campaigns/sources/actions";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import DynamicFormToFilter from "../../../components/forms/DynamicFormToFilter";
import {
  getCurrentDay,
  getSelectedMonthAgo,
} from "../../../helpers/utils";
import ReactTableForm from "../../../components/Common/ReactTableForm";
import MiniWidget from "../../../components/MiniWidget";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class ManagersReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {
        page: 1,
        size: 10,
        results: [
          {
            platform: "Facebook",
            payment: "200 000$",
            cost: "230 000$",
            rebates: "30 000$",
            balance: "0",
          },
          {
            platform: "Facebook",
            payment: "400 000$",
            cost: "430 000$",
            rebates: "130 000$",
            balance: "0",
          },
        ],
      },
      columns: [
        {
          Header: "Platform",
          accessor: "platform",
          isSorted: true,
        },
        {
          Header: "Payment",
          accessor: "payment",
          isSorted: true,
        },
        {
          Header: "Cost",
          accessor: "cost",
          isSorted: true,
        },
        {
          Header: "Rebates",
          accessor: "rebates",
          isSorted: true,
        },
        {
          Header: "Balance",
          accessor: "balance",
          isSorted: true,
        },
      ],
      reports: null,
    };
  }

  componentDidMount() {
    const data = {};

    if (this.props.managersDate === null) {
      data.start_date = getSelectedMonthAgo(2);
      data.end_date = getCurrentDay();
      this.props.setManagersReportDate(data);

      this.props.getOffers({
        ...this.props.offers,
        is_main: false,
      });
      this.props.getCampaignSourcesList(this.props.sourceList);
    } else {
      let managersDate = this.props.managersDate;
      let updateManagersDate = {};
      updateManagersDate.start_date = managersDate.start_date;
      updateManagersDate.end_date = managersDate.end_date;
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    console.log(this.props.sourceList);
  }

  onFiltersChange = (type, filter, dateTime) => {
    if (type === "data") {
      console.log("Change data");
      console.log(filter);
      console.log(dateTime);
    } else if (type === "date") {
      console.log("Change date");
      console.log(filter);
    }
  };

  onGenerateOffers = offers => {};

  render() {
    return (
      <>
        <React.Fragment>
          <div className="page-content">
          <ModifiedMetaTags title="Managers report | Mobihunter" />

            <Container fluid>
              <Breadcrumbs
                title="Dashboard"
                breadcrumbItem="Managers report"
                link="/managers-report"
              />

              <DynamicFormToFilter
                onFiltersChange={this.onFiltersChange}
                filtersFields={[
                  // {
                  //   filterData: [], //this.props?.offers,
                  //   plug: "Offers...",
                  //   filterType: "offers",
                  // },
                  {
                    filterData: [], //this.props.sourceList?.results,
                    plug: "Platforms...",
                    filterType: "platforms",
                  },
                  {
                    filterData: [],
                    plug: "Managers...",
                  },
                  {
                    filterData: [],
                    plug: "Media buyers...",
                  },
                  // {
                  //   filterData: [],
                  //   plug: "Index...",
                  // },
                ]}
                selectedDate={this.props.managersDate}
                filtered_by={["media_source", "mediabuyers"]}
                autoCheckedAll
              />

              {this.state.reports !== null && (
                <Col xl={12}>
                  <Row>
                    <MiniWidget data={this.state.reports} />
                  </Row>
                </Col>
              )}
              <Row>
                <Col className="col-12">
                  <Card>
                    <CardBody>
                      <Row className="justify-content-between align-middle">
                        <Col xs={6}>
                          {/* <h4 className="mb-3">Managers report</h4> */}
                        </Col>
                      </Row>
                      <ReactTableForm
                        columns={this.state.columns}
                        data={this.state.data}
                        onTableChange={this.onTableChange}
                        //loading={this.props.loading}
                        // pagination
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </React.Fragment>
      </>
    );
  }
}

ManagersReport.propTypes = {
  managersDate: PropTypes.any,
  offers: PropTypes.any,
  ad_platforms: PropTypes.any,
  sourceList: PropTypes.any,
  setManagersReportDate: PropTypes.func,
  getOffers: PropTypes.func,
  getCampaignSourcesList: PropTypes.func,
};

const mapStateToProps = state => ({
  managersDate: state.Reporting.managersDate,
  offers: state.Offers.offers,
  sourceList: state.CampaignSourceList.data,
});

export default connect(mapStateToProps, {
  setManagersReportDate,
  getOffers,
  getCampaignSourcesList,
})(ManagersReport);
